var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8221 11.577L8.16491 4.91339C8.04269 4.80872 7.88548 4.75403 7.72468 4.76024C7.56389 4.76645 7.41136 4.83311 7.29758 4.94689C7.1838 5.06067 7.11714 5.2132 7.11093 5.374C7.10472 5.53479 7.15941 5.692 7.26408 5.81422L13.0141 11.5642L7.25129 17.244C7.14662 17.3662 7.09193 17.5234 7.09814 17.6842C7.10435 17.845 7.17101 17.9975 7.28479 18.1113C7.39857 18.2251 7.5511 18.2917 7.71189 18.2979C7.87269 18.3041 8.0299 18.2495 8.15212 18.1448L14.8221 11.577Z",
    fill: "#5FD0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7811 11.577L9.1239 4.91339C9.00168 4.80872 8.84446 4.75403 8.68367 4.76024C8.52287 4.76645 8.37035 4.83311 8.25656 4.94689C8.14278 5.06067 8.07613 5.2132 8.06991 5.374C8.0637 5.53479 8.1184 5.692 8.22306 5.81422L13.9731 11.5642L8.21027 17.244C8.10561 17.3662 8.05091 17.5234 8.05712 17.6842C8.06333 17.845 8.12999 17.9975 8.24377 18.1113C8.35756 18.2251 8.51008 18.2917 8.67088 18.2979C8.83167 18.3041 8.98889 18.2495 9.11111 18.1448L15.7811 11.577Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c6be8627d8313f5554dd5b9fac69b097.svg";
export { ForwardRef as ReactComponent };